import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Slider } from '@/components/ui/slider';
import { Badge } from '@/components/ui/badge';
import { Heading } from '@/components/ui/heading';
import type { JournalWarmupState } from '@domain/journal';
import { JOURNAL_STEP_ICONS } from './stepIcons';

export type WarmupStepProps = {
  state: JournalWarmupState;
  onWarmupChange: (key: keyof JournalWarmupState, value: number) => void;
  onWarmupCommit: (key: keyof JournalWarmupState, value: number) => void;
  onContinue: () => void;
};

export default function WarmupStep({
  state,
  onWarmupChange,
  onWarmupCommit,
  onContinue,
}: WarmupStepProps) {
  const StepIcon = JOURNAL_STEP_ICONS.warmup;
  const moodValue = state.moodLevel ?? 5;
  const energyValue = state.energyLevel ?? 5;
  const canContinue = state.moodLevel != null && state.energyLevel != null;

  return (
    <Card>
      <CardHeader>
        <Heading
          level={2}
          icon={StepIcon}
          description="Imposta il tuo livello di umore ed energia per capire da dove partire."
          wrapperClassName="mb-6"
        >
          Come ti senti oggi?
        </Heading>
      </CardHeader>

      <CardContent className="space-y-6">
        <div>
          <div className="flex items-center justify-between">
            <span className="font-medium">Umore</span>
            <Badge variant="secondary">{state.moodLevel ?? '—'}</Badge>
          </div>
          <Slider
            min={0}
            max={10}
            step={1}
            color={state.moodLevel ? 'primary' : 'gray'}
            value={[moodValue]}
            onValueChange={(values) => onWarmupChange('moodLevel', values[0] ?? moodValue)}
            onValueCommit={(values) => onWarmupCommit('moodLevel', values[0] ?? moodValue)}
            className="mt-3"
          />
        </div>

        <div>
          <div className="flex items-center justify-between">
            <span className="font-medium">Energia</span>
            <Badge variant="secondary">{state.energyLevel ?? '—'}</Badge>
          </div>
          <Slider
            min={0}
            max={10}
            step={1}
            color={state.energyLevel ? 'primary' : 'gray'}
            value={[energyValue]}
            onValueChange={(values) => onWarmupChange('energyLevel', values[0] ?? energyValue)}
            onValueCommit={(values) => onWarmupCommit('energyLevel', values[0] ?? energyValue)}
            className="mt-3"
          />
        </div>

        <div className="flex justify-end">
          <Button disabled={!canContinue} onClick={onContinue}>
            Continua
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
